import Link from "next/link";
import Image from "next/image";
import { useRouter } from "next/router";
import { useEffect, useState } from "react";
import NavLinks from "./nav-links";
import LoginForm from "@/components/product-gallery-page/section/loginForm";
import { document } from "postcss";
import Corporate from "./corporate";
import Search from "./search";
import WhereToBuy from "./where-to-buy";
import Language from "./language";
import MobLinks from "./mob-links";
import fetchHeaderFooterData from "@/hooks/fetchHeaderFooterData";
import { MEDIA_BASE_URL } from "@/utils/api";
import { parseCookies } from "nookies";
import Cookies from "js-cookie";
import ResponsiveSearch from "./responsive-search";

const Header = () => {
  const mediaBaseUrl = MEDIA_BASE_URL;

  // get header api data
  const { headerApiData } = fetchHeaderFooterData();
  const router = useRouter();
  const [scrolled, setScrolled] = useState(false);
  const [showResponsiveSearchIcon, setShowResponsiveSearchIcon] = useState(false)
  const [screenwidth, setScreenwidth] = useState(false);
  const [menuactive, setMenuactive] = useState(false);
  const [showMobilePopup, setShowMobilePopup] = useState(false);
  const [showCorporateDropdown, setShowCorporateDropdown] = useState(false);
  const loginHandler = () => {
    setShowMobilePopup(true);
  };
  const handleClosePopup = (popupName) => {
    setShowMobilePopup(false);
  };

  useEffect(() => {
    const handleScroll = () => {
      const isScrolled = window.scrollY > 150;
      setScrolled(isScrolled);
    };

    handleScroll();
    window.addEventListener("scroll", handleScroll);
    const handleResize = () => {
      const width = window.innerWidth < 1024;
      setScreenwidth(width);
    };
    handleResize();
    window.addEventListener("resize", handleResize);

    return () => {
      window.removeEventListener("scroll", handleScroll);
      window.removeEventListener("resize", handleResize);
    };
  }, []);

  useEffect(() => {
    const cookies = parseCookies();
    const user = cookies.user ? JSON.parse(cookies.user) : {};
    setUserMenuDisplay(user && Object.keys(user).length > 0);
  }, []);


  function menuBtn() {
    setMenuactive(!menuactive);
  }
  const isHomePage = router.pathname === "/";

  const [dropDown, setDropDown] = useState(false);
  const [userMenuDisplay, setUserMenuDisplay] = useState(false);

  // Ensure that the state update for `userMenuDisplay` only happens in the useEffect hook
  useEffect(() => {
    const cookies = parseCookies();
    const user = JSON.parse(cookies.user || "{}");

    if (user && Object.keys(user).length > 0) {
      setUserMenuDisplay(true);
    } else {
      setUserMenuDisplay(false);
    }
  }, []);

  const dropdownHandler = () => {
    setDropDown((prevState) => !prevState);
  };
  const logoutHandler = () => {
    Cookies.remove("token");
    Cookies.remove("user");
    window.location.href = "/";
  };

  const toggleSearchIcon = () => {
    if (showResponsiveSearchIcon) {
      setTimeout(() => {
        setShowResponsiveSearchIcon(false);
      }, 500);
    } else {
      setShowResponsiveSearchIcon(true);
    }
  }


  return (
    <>
      <header
        className={`transition-all duration-500 ${isHomePage && !scrolled && !screenwidth ? "homeHeader" : ""
          }`}
      >
        <div className="container py-3 lg:py-[1vw] z-[9] relative lg:px-[4vw]">
          <div className="flex justify-between relative lg:justify-center ">
            {!screenwidth && (
              <div
                onClick={() => { setShowCorporateDropdown(true) }}
                className="flex-none absolute left-0 top-1/2 translate-y-[-50%]">
                <Corporate
                  showCorporateDropdown={showCorporateDropdown}
                />
              </div>
            )}
            <div>
              {headerApiData?.logo && headerApiData?.logo_light && <Link
                href={"/"}
                className={`block w-20 sm:w-32  ease-in-out duration-500 lg:w-[7vw] logo`}
                // prefetch={false}
              >
                {headerApiData.logo && <Image
                  src={`${mediaBaseUrl}${headerApiData.logo}`}
                  width={250}
                  height={80}
                  alt="Logo"
                  className="blackLogo"
                />}
                {headerApiData.logo_light && <Image
                  src={`${mediaBaseUrl}${headerApiData.logo_light}`}
                  width={250}
                  height={80}
                  alt="Logo"
                  className="whiteLogo"
                />}
              </Link>}
            </div>

            <div className="flex-none absolute right-0 top-1/2 translate-y-[-50%]  ">
              <ul className={`headRightBox flex items-center`}>
                <li className="">
                  <Search />
                </li>
                {/* <li
                  onClick={toggleSearchIcon}
                  className="header searchIcon lg:hidden">
                  <svg
                    className=''
                    xmlns="http://www.w3.org/2000/svg"
                    viewBox="0 0 30 30"
                    width="30px"
                    height="30px">
                    <path
                      d="M 13 3 C 7.4889971 3 3 7.4889971 3 13 C 3 18.511003 7.4889971 23 13 23 C 15.396508 23 17.597385 22.148986 19.322266 20.736328 L 25.292969 26.707031 A 1.0001 1.0001 0 1 0 26.707031 25.292969 L 20.736328 19.322266 C 22.148986 17.597385 23 15.396508 23 13 C 23 7.4889971 18.511003 3 13 3 z M 13 5 C 17.430123 5 21 8.5698774 21 13 C 21 17.430123 17.430123 21 13 21 C 8.5698774 21 5 17.430123 5 13 C 5 8.5698774 8.5698774 5 13 5 z"
                    />
                  </svg>
                </li> */}
                <div className="w-[2px] h-[200%] border-r ml-[-18px] hidden lg:block">&nbsp;</div>
                <li className="hidden lg:block whereToBuy"
                >
                  <WhereToBuy setMenuactive={setMenuactive} />
                </li>
                <div className="w-[2px] h-[200%] border-r  ml-[-18px] hidden lg:block">&nbsp;</div>
                <li className="mt-[-8px]  hidden lg:block">
                  <Language
                    customClass={isHomePage && !scrolled && !screenwidth ? 'text-white' : 'text-black'}
                  />
                </li>
                <div className="w-[2px] h-[200%] border-r hidden lg:block  ml-[-24px]">&nbsp;</div>
                <li className="">
                  {userMenuDisplay ? (
                    <div className="login relative">
                      <span className="block" onClick={dropdownHandler}>
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          width="16"
                          height="16"
                          fill="#000"
                          className="bi bi-person-circle"
                          viewBox="0 0 16 16"
                        >
                          <path d="M11 6a3 3 0 1 1-6 0 3 3 0 0 1 6 0" />
                          <path
                            fillRule="evenodd"
                            d="M0 8a8 8 0 1 1 16 0A8 8 0 0 1 0 8m8-7a7 7 0 0 0-5.468 11.37C3.242 11.226 4.805 10 8 10s4.757 1.225 5.468 2.37A7 7 0 0 0 8 1"
                          />
                        </svg>
                      </span>

                      {dropDown && (
                        <div className="absolute right-0 top-[25px] bg-[#e9e9e9] rounded loginDropDown py-3 px-4 shadow-lg">
                          <Link
                            href="/profile"
                            className="block pb-3 whitespace-nowrap text-black"
                            onClick={dropdownHandler}
                          >
                            Profile
                          </Link>
                          <Link
                            href="/favourites"
                            className="block pb-3 whitespace-nowrap"
                            onClick={dropdownHandler}
                          >
                            Favourites
                          </Link>
                          <Link
                            href="#"
                            className="block whitespace-nowrap text-black"
                            onClick={logoutHandler}
                          >
                            Logout
                          </Link>
                        </div>
                      )}
                    </div>
                  ) : (
                    <span className="block" onClick={loginHandler}>
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width="16"
                        height="16"
                        fill="#000"
                        className="bi bi-person-circle"
                        viewBox="0 0 16 16"
                      >
                        <path d="M11 6a3 3 0 1 1-6 0 3 3 0 0 1 6 0" />
                        <path
                          fillRule="evenodd"
                          d="M0 8a8 8 0 1 1 16 0A8 8 0 0 1 0 8m8-7a7 7 0 0 0-5.468 11.37C3.242 11.226 4.805 10 8 10s4.757 1.225 5.468 2.37A7 7 0 0 0 8 1"
                        />
                      </svg>
                    </span>
                  )}
                </li>

                {screenwidth && (
                  <li>
                    <button
                      onClick={menuBtn}
                      className={`menuBtn ${menuactive ? "active" : ""}`}
                    >
                      <span></span>
                      <span></span>
                      <span></span>
                      <span></span>
                    </button>
                  </li>
                )}
              </ul>
            </div>
          </div>
        </div>
        <nav className="thinBorder hidden lg:block">
          <div className="container relative">
            <NavLinks
              customClass={`${scrolled ? "*:lg:py-[.9vw]" : "*:lg:py-[1vw]"}`}
            />
          </div>
        </nav>
        <nav
          className={`bg-light-black absolute w-full h-[calc(89.5vh)] overflow-y-auto hidden ${menuactive ? "!block" : ""}`}
        >
          <div className="container px-0">
            <MobLinks
              customClass={"*:py-4 *:text-white"}
              menuBtn={menuBtn}
              setMenuactive={setMenuactive}
            />
            <div className="border-t border-solid border-primary lg:gap-x-[3.333vw] px-5">
              <ul className="*:lg:text-[0.938vw] *:font-secondary *:lg:py-[1vw]  *:py-4 *:text-white">
                <li>
                  <Corporate
                    customClass={"relative "}
                    setMenuactive={setMenuactive}
                    listStyle={
                      "*:py-4 *:border-b *:border-solid *:border-[#111]"
                    }
                  />
                </li>
                <li>
                  <WhereToBuy
                    setMenuactive={setMenuactive}
                  />
                </li>
                {/* <li>
                  <Language />
                </li> */}
              </ul>
            </div>
          </div>

        </nav>

        {showResponsiveSearchIcon && (
          <div
            className={`h-20 w-[100vw] mt-0 z-[100] search_responsive 
                transition-all duration-500 ease-[cubic-bezier(0.4, 0, 0.2, 1)] 
                ${showResponsiveSearchIcon ? "opacity-100 translate-y-0" : "opacity-0 -translate-y-20"}`}
          >
            <ResponsiveSearch
              toggleSearchIcon={toggleSearchIcon}
            />
          </div>
        )}

      </header>
      {showMobilePopup && <LoginForm handleClosePopup={handleClosePopup} />}
    </>
  );
};

export default Header;
